import { React, useState, forwardRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

export default function InputController(props) {
  const [register, setRegister] = useState(props);
  return (
    <Controller
      render={({ field }) => (
        <TextField
          onChange={(value) => {
            field.onChange(value);
            if(typeof props.changeHandler === 'function'){ props.changeHandler(value);}
            //if(props.total) props.total(field.name, value.target.value)
            if(props.onFieldChange) {
              props.onFieldChange(value)
            }
          }}
          value={props.value === undefined ? field.value : props.value}

          // inputRef={field.ref}
          InputLabelProps={{ shrink: true }}
          label={props.placeholder}
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{props.symbol}</InputAdornment>
            ),
          }}
          type={props.type}
          fullWidth
          error={props.error ? true : false}
          disabled = {props.disabled ? 'disabled' : ''}
        />
      )}
      name={props.name}
      {...register.register}
      control={props.control}
      rules={{ required: true }}
      defaultValue = ''
    />
  );
}
